
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.5 5.543c-.6 0-1.187.174-1.687.499-.499.325-.888.786-1.118 1.327-.23.54-.29 1.134-.173 1.708.117.573.407 1.1.831 1.514.425.413.966.695 1.555.809.589.114 1.2.055 1.754-.168a3.02 3.02 0 001.362-1.09 2.902 2.902 0 00.512-1.642 2.927 2.927 0 00-.892-2.088A3.087 3.087 0 008.5 5.543zM15.055 8.5a5.958 5.958 0 01-.063.826l1.848 1.408a.419.419 0 01.1.546l-1.748 2.94a.44.44 0 01-.234.186.453.453 0 01-.303-.004l-2.172-.85c-.453.339-.948.62-1.473.837l-.325 2.247a.438.438 0 01-.152.258.46.46 0 01-.285.106H6.752a.463.463 0 01-.282-.102.442.442 0 01-.155-.25l-.325-2.246a6.466 6.466 0 01-1.473-.839l-2.172.85a.453.453 0 01-.303.004.44.44 0 01-.234-.186L.06 11.293a.419.419 0 01.1-.546l1.848-1.41a6.287 6.287 0 01-.063-.837c.002-.276.023-.552.063-.826L.16 6.266a.419.419 0 01-.1-.546l1.748-2.94a.44.44 0 01.234-.186.453.453 0 01.303.004l2.172.85c.453-.339.948-.62 1.473-.837L6.315.364a.438.438 0 01.152-.258A.46.46 0 016.752 0h3.496a.463.463 0 01.282.102c.079.064.134.152.155.25l.325 2.246a6.468 6.468 0 011.475.839l2.17-.85a.453.453 0 01.303-.004.44.44 0 01.234.186l1.748 2.939a.419.419 0 01-.1.546l-1.848 1.409c.04.277.06.557.063.837z","fill":"#AFAFAF"}})])
          )
        }
      }
    